/**
 * صفوف «معلومات الأرض» من استجابة GET /api/donations/lands/:id (أو أي كائن يحمل نفس الحقول).
 * يدعم أسماء حقول متعددة حسب ما يعيده الـ backend.
 */

export type LandInfoRows = {
  sequence: string;
  region: string;
  city: string;
  center: string;
  district: string;
  fullAddress: string;
  donationType: string;
};

function pickFromLand(land: Record<string, unknown>, ...keys: string[]): string {
  for (const k of keys) {
    const v = land[k];
    if (typeof v === "string" && v.trim()) return v.trim();
    if (typeof v === "number" && Number.isFinite(v)) return String(v);
  }
  return "";
}

/** عند عدم إرجاع نص نوع المساهمة من الـ API */
const DONATION_TYPE_LABEL_FALLBACK: Record<number, string> = {
  1: "بناء أرض مسجد مع مرافقه",
};

export function buildLandInfoRows(
  land: Record<string, unknown>,
  landLabel: string,
  fullAddr: string
): LandInfoRows {
  const sequence =
    pickFromLand(land, "sequence", "Sequence", "landNumber", "LandNumber", "landCode", "LandCode", "code", "Code") ||
    landLabel;
  let donationType = pickFromLand(land, "donationType", "DonationType", "donationTypeName", "DonationTypeName");
  if (!donationType) {
    const id = land.donationTypeId ?? land.DonationTypeId;
    if (typeof id === "number" && DONATION_TYPE_LABEL_FALLBACK[id]) {
      donationType = DONATION_TYPE_LABEL_FALLBACK[id];
    }
  }
  return {
    sequence,
    region: pickFromLand(land, "regionName", "RegionName", "region_name"),
    city: pickFromLand(land, "cityName", "CityName", "city_name"),
    center: pickFromLand(land, "centerName", "CenterName", "moiaCenterName", "MoiaCenterName", "center_name"),
    district: pickFromLand(land, "districtName", "DistrictName", "district_name"),
    fullAddress: fullAddr,
    donationType,
  };
}
